import IntakeStatusTag from './IntakeStatusTag.component';

export default IntakeStatusTag;
